import { useDispatch } from 'react-redux';
import { set_active_task } from '../../../redux/taskSlice';
import { useNavigate } from 'react-router-dom';

const TaskMessage = ({ msg, is_reply_head }) => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const viewTask = () => {
        if (is_reply_head) return;
        dispatch(set_active_task(msg?.task_data));
        navigate(`${msg?.task_data?._id}`);
    };

    return (
        <div className="bg-teal-100 rounded-md bgSurfaceDarkBox">
            <div className="p-2.5 group rounded-md border dark:border-none border-teal-200" onClick={viewTask} style={{ cursor: 'pointer' }}>
                <div className="msg_link_container flex flex-col">
                    <div className='flex gap-1 mb-1 items-center'>
                        <div className='taskChatIcons' style={{backgroundSize: "22px"}}></div>
                        <p className='text-sm text-grey-600 dark:text-white dark:text-white break-words'> {msg?.task_data?.task_title}</p>
                    </div>

                    <div className='flex items-center ml-5'>
                        <div className='privateLockTeal' style={{backgroundSize: "16px"}} />
                        <p className='text-[10px] text-grey-600 dark:text-white dark:text-white'>
                            Only assignee, observers, and you can see this task.
                        </p>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default TaskMessage;